import * as Yup from "yup";
const FILE_SIZE = 250 * 1024; // 200KB in bytes
const SUPPORTED_FORMATS = ["image/jpeg", "image/png"];
const EDIT_SUPPORTED_FORMATS = ["image/jpeg", "image/png", ""]

export const loginSchema = Yup.object().shape({
  username: Yup.string()
    .required("Email or phone number is required")
    .matches(
      /^(?:[0-9]{10}|[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})$/,
      "Invalid email or phone number format"
    ),
  password: Yup.string().required("Password is required"),
});

export const countrySchema = Yup.object().shape({
  name: Yup.string().required("Country Name is required"),
  phone_min: Yup.string()
    .required("Phone Number Minimum is required")
    .test(
      "is-valid-number",
      "Phone Number Minimum must be between 0 and 15",
      (value) => {
        const parsedValue = parseInt(value, 10);
        return !isNaN(parsedValue) && parsedValue >= 0 && parsedValue <= 15;
      }
    ),

  phone_max: Yup.string()
    .required("Phone Number Maximum is required")
    .test(
      "is-valid-number",
      "Phone Number Maximum must be between 0 and 15",
      (value) => {
        const parsedValue = parseInt(value, 10);
        return !isNaN(parsedValue) && parsedValue >= 0 && parsedValue <= 15;
      }
    ),

  // phone_max: Yup.string().required("Phone Number Maximum  is required"),
  phone_code: Yup.string().required("Phone Code is required"),
  short_country_code: Yup.string().required("Short Country Code is required"),
  country_code: Yup.string().required("Country Code is required"),
  sorting: Yup.string().required("Sorting is required"),
});

export const stateSchema = Yup.object().shape({
  name: Yup.string().required("State Name is required"),
  sorting: Yup.string().required("Sorting is required"),
  country_id: Yup.string().required("Country is required"),
});
export const feedbackSchema = Yup.object().shape({
  name: Yup.string().required("Feedaback is required"),
  sorting: Yup.string().required("Sorting is required"),
});
export const contentSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  sorting: Yup.string().required("Sorting is required"),
});

export const roleSchema = Yup.object().shape({
  name: Yup.string().required("Role Name is required"),
  sorting: Yup.string().required("Sorting is required"),
});
export const genreSchema = Yup.object().shape({
  name: Yup.string().required("Genre Name is required"),
  sorting: Yup.string().required("Sorting is required"),
  imageUpload: Yup.mixed()
    .required("An image is required")
    .test(
      "fileFormat",
      "Unsupported Format",
      (value) => value && SUPPORTED_FORMATS.includes(value.type)
    )
    .test(
      "fileSize",
      "File size exceeds the limit of 250KB",
      (value) => value && value.size <= FILE_SIZE
    ),
});
export const genreUpdateSchema = Yup.object().shape({
  name: Yup.string().required("Genre Name is required"),
  sorting: Yup.string().required("Sorting is required"),
  imageUpload: Yup.mixed()
    .nullable()
    .test(
      "fileSize",
      "File size is too large (Max size is 250 KB)",
      (value) => !value || (value && value.size <= FILE_SIZE)
    )
    .test(
      "fileFormat",
      "Unsupported file format (Only JPEG and PNG are allowed)",
      (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
    ),
});

export const districtSchema = Yup.object().shape({
  name: Yup.string().required("District   Name is required"),
  sorting: Yup.string().required("Sorting is required"),
  state_id: Yup.string().required("State is required"),
});

export const voiceSchema = Yup.object().shape({
  sorting: Yup.string().required("Sorting is required"),
  name: Yup.string().required("Voice Name is required"),
  imageUpload: Yup.mixed()
    .required("An image is required")
    .test(
      "fileFormat",
      "Unsupported Format",
      (value) => value && SUPPORTED_FORMATS.includes(value.type)
    )
    .test(
      "fileSize",
      "File size exceeds the limit of 250KB",
      (value) => value && value.size <= FILE_SIZE
    ),
});
export const voiceUpdateSchema = Yup.object().shape({
  sorting: Yup.string().required("Sorting is required"),
  imageUpload: Yup.mixed()
    .nullable()
    .test(
      "fileSize",
      "File size is too large (Max size is 250 KB)",
      (value) => !value || (value && value.size <= FILE_SIZE)
    )
    .test(
      "fileFormat",
      "Unsupported file format (Only JPEG and PNG are allowed)",
      (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
    ),
  name: Yup.string().required("Voice Name is required"),
});

export const membershipSchema = Yup.object().shape({
  name: Yup.string().required("Plan Name is required"),
  sorting: Yup.string().required("Sorting is required"),
  duration: Yup.string().required("Duration is required"),
  price: Yup.string().required("Price is required"),
  formRows2: Yup.array().of(
    Yup.object().shape({
      content: Yup.string().required("Description is required"),

    })
  ),
});

// export const bannerSchema = Yup.object().shape({
//   sorting: Yup.string().required("Sorting is required"),
//   row: Yup.string().required("Row is required"),
//   // type: Yup.string().required("Type is required"),
//   type: Yup.string().required("Banner Type is required"),
//   image: Yup.mixed()
//     .required("An image is required")
//     .test(
//       "fileFormat",
//       "Unsupported Format",
//       (value) => value && SUPPORTED_FORMATS.includes(value.type)
//     )
//     .test(
//       "fileSize",
//       "File size exceeds the limit of 250KB",
//       (value) => value && value.size <= FILE_SIZE
//     ),
// });

export const bannerSchema = Yup.object().shape({
  sorting: Yup.string().required("Sorting is required"),
  row: Yup.string().required("Row is required"),
  type: Yup.string().required("Banner Type is required"),
  image: Yup.mixed()
    .required("An image is required")
    .test(
      "fileFormat",
      "Unsupported Format",
      (value) => value && SUPPORTED_FORMATS.includes(value.type)
    )
    .test(
      "fileSize",
      "File size exceeds the limit of 250KB",
      (value) => value && value.size <= FILE_SIZE
    ),
  media_id: Yup.string()
    .nullable()
    .test(
      "mediaRequiredForType1or2",
      "Media is required when Banner Type is 1 or 2",
      function (value) {
        const { type } = this.parent; // Access the banner type value
        if ((type === '1' || type === '2') && !value) {
          return false;
        }
        return true;
      }
    ),
  post_id: Yup.string()
    .nullable()
    .test(
      "postRequiredForType3",
      "Post is required when Banner Type is 3",
      function (value) {
        const { type } = this.parent; // Access the banner type value
        if (type === '3' && !value) {
          return false;
        }
        return true;
      }
    ),
});

export const bannerUpdateSchema = Yup.object().shape({
  sorting: Yup.string().required("Sorting is required"),
  row: Yup.string().required("Row is required"),
  // type: Yup.string().required("Type is required"),
  image: Yup.mixed()
    .nullable()
    .test(
      "fileSize",
      "File size is too large (Max size is 250 KB)",
      (value) => !value || (value && value.size <= FILE_SIZE)
    )
    .test(
      "fileFormat",
      "Unsupported file format (Only JPEG and PNG are allowed)",
      (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
    ),

});

export const authorSchema = Yup.object().shape({
  sorting: Yup.string().required("Sorting is required"),
  name: Yup.string().required(" Author Name is required"),
  image: Yup.mixed()
    .required("An image is required")
    .test(
      "fileFormat",
      "Unsupported Format",
      (value) => value && SUPPORTED_FORMATS.includes(value.type)
    )
    .test(
      "fileSize",
      "File size exceeds the limit of 250KB",
      (value) => value && value.size <= FILE_SIZE
    ),
});

export const authorUpdateSchema = Yup.object().shape({
  sorting: Yup.string().required("Sorting is required"),
  name: Yup.string().required("Author Name is required"),
  image: Yup.mixed()
    .nullable()
    .test(
      "fileSize",
      "File size is too large (Max size is 250 KB)",
      (value) => !value || (value && value.size <= FILE_SIZE)
    )
    .test(
      "fileFormat",
      "Unsupported file format (Only JPEG and PNG are allowed)",
      (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
    ),
});

export const postSchema = Yup.object().shape({
  sorting: Yup.string().required("Sorting is required"),
  title: Yup.string().required(" Post Title is required"),
  // original_author_ids: Yup.array()
  //   .min(1, "Author Name is required")
  //   .required("Author Name is required"),
  type: Yup.string().required("Post Type is required"),
  image: Yup.mixed()
    .required("An image is required")
    .test(
      "fileFormat",
      "Unsupported Format",
      (value) => value && SUPPORTED_FORMATS.includes(value.type)
    )
    .test(
      "fileSize",
      "File size exceeds the limit of 250KB",
      (value) => value && value.size <= FILE_SIZE
    ),
  formRows: Yup.array().of(
    Yup.object().shape({
      sorting: Yup.string().required("Sorting is required"),
      type: Yup.number().required("Type is required"),

      description: Yup.string().test(
        'description-required',
        'Description is required when type is Description',
        function (value) {
          const { type } = this.parent; // Access type field in the same object
          return type !== 2 || (type === 2 && value && value.trim().length > 0);
        }
      ),

      image: Yup.mixed().nullable().test(
        'image-required',
        'An image is required when type is Image',
        function (value) {
          const { type } = this.parent; // Access type field in the same object
          if (type === 1) {
            return value !== null;
          }
          return true;
        }
      ).test(
        'fileFormat',
        'Unsupported Format',
        function (value) {
          const { type } = this.parent; // Access type field in the same object
          return type !== 1 || (value && SUPPORTED_FORMATS.includes(value.type));
        }
      ).test(
        'fileSize',
        'File size exceeds the limit of 250KB',
        function (value) {
          const { type } = this.parent; // Access type field in the same object
          return type !== 1 || (value && value.size <= FILE_SIZE);
        }
      ),
    })
  ),
});

export const postUpdateSchema = Yup.object().shape({
  sorting: Yup.string().required("Sorting is required"),
  title: Yup.string().required(" Post Title is required"),
  original_author_ids: Yup.array(),
    // .min(1, "Author Name is required")
    // .required("Author Name is required"),
  type: Yup.string().required("Post Type is required"),
  image: Yup.mixed()
    .nullable()
    .test(
      "fileSize",
      "File size is too large (Max size is 250 KB)",
      (value) => !value || (value && value.size <= FILE_SIZE)
    )
    .test(
      "fileFormat",
      "Unsupported file format (Only JPEG and PNG are allowed)",
      (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
    ),
  formRows: Yup.array().of(
    Yup.object().shape({
      sorting: Yup.string().required("Sorting is required"),
      type: Yup.number().required("Type is required"),

      description: Yup.string().test(
        'description-required',
        'Description is required when type is Description',
        function (value) {
          const { type } = this.parent; // Access type field in the same object
          return type !== 2 || (type === 2 && value && value.trim().length > 0);
        }
      ),
      image: Yup.mixed().nullable().test(
        'image-validation',
        'An image is required when type is Image and file size should be 250kb',
        function (value) {
          const { type } = this.parent; // Access type field in the same object

          if (type === 1) {
            // Ensure the image field is valid based on type
            return (
              typeof value === 'object' &&
              value !== null &&
              // (value.image_url && value.image_url.includes('scrum') ||
              //   (value.size <= FILE_SIZE && EDIT_SUPPORTED_FORMATS.includes(value.type)))
              (value.image_url  ||
                (value.size <= FILE_SIZE && EDIT_SUPPORTED_FORMATS.includes(value.type)))
            );
          }

          return true;
        }
      ),

    })
  ),


});

export const mediaSchema = Yup.object().shape({
  sorting: Yup.string().required("Sorting is required"),
  title: Yup.string().required("Media Title is required"),
  description: Yup.string().required("Description is required"),
  purchase_type: Yup.string().required("Purchase type is required"),
  type: Yup.string().required(" Media Type is required"),
  genre_ids: Yup.array()
    .min(1, "Genre Name is required")
    .max(3, "Maximum 3 can be selected")
    .required("Genre Name is required"),
  original_author_ids: Yup.array()
    .min(1, "Author Name is required")
    .required("Author is required"),
  voice_ids: Yup.array()
    .min(1, "Voice Name is required")
    .required("Voice Name is required"),
  imageUpload: Yup.mixed()
    .required("An image is required")
    .test(
      "fileFormat",
      "Unsupported Format",
      (value) => value && SUPPORTED_FORMATS.includes(value.type)
    )
    .test(
      "fileSize",
      "File size exceeds the limit of 250KB",
      (value) => value && value.size <= FILE_SIZE
    ),
  mediaUpload: Yup.mixed().required("A file is required"),

});

export const mediaUpdateSchema = Yup.object().shape({
  sorting: Yup.string().required("Sorting is required"),
  title: Yup.string().required("Media Title is required"),
  description: Yup.string().required("Description is required"),
  type: Yup.string().required(" Media Type is required"),
  purchase_type: Yup.string().required("Purchase type is required"),
  genre_ids: Yup.array()
    .min(1, "Genre Name is required")
    .max(3, "Maximum 3 can be selected")
    .required("Genre Name is required"),
  original_author_ids: Yup.array()
    .min(1, "Author Name is required")
    .required("Author Name is required"),
  voice_ids: Yup.array()
    .min(1, "Voice Name is required")
    .required("Voice Name is required"),
  imageUpload: Yup.mixed()
    .nullable()
    .test(
      "fileSize",
      "File size is too large (Max size is 250 KB)",
      (value) => !value || (value && value.size <= FILE_SIZE)
    )
    .test(
      "fileFormat",
      "Unsupported file format (Only JPEG and PNG are allowed)",
      (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
    ),
});

export const userSchema = Yup.object().shape({
  short_name: Yup.string().required("Short Name is required"),
  // role_id: Yup.string().required("Role is required"),
  country_id: Yup.string().required("Country is required"),
  district_id: Yup.string().required("District is required"),
  state_id: Yup.string().required("State is required"),
  email: Yup.string()
    .required("Email is required")
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Email must be a valid email address"
    ),
});

export const profileSchema = Yup.object().shape({
  // short_name: Yup.string().required("Name is required"),
  // role_id: Yup.string().required("Role is required"),
  // country_id: Yup.string().required("Country is required"),
  // district_id: Yup.string().required("District is required"),
  // state_id: Yup.string().required("State is required"),
  // email: Yup.string()
  //   .required("Email is required")
  //   .email("Invalid email format")
  //   .matches(
  //     /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  //     "Email must be a valid email address"
  //   ),
});
